import recipes from "./recipes";

const mapDownloadBanner = (response: any) => {
  const data: any = {};

  data.appBanner = {
    title:
      response?.footer_title ||
      "Find more amazing recipes on the Shyft App. Download Now!",
    appCard: {
      title:
        response?.footer_title ||
        "Find more amazing recipes on the Shyft App. Download Now!",
      subtitle:
        response?.footer_sub_title ||
        "Download Shyft Health App and start your wellness journey",
      appLinks: [
        {
          link:
            response?.download_app_url?.play_store_link ||
            "https://mindhouse.app.link/bugSoTgftwb",
          icon: "https://d1mxd7n691o8sz.cloudfront.net/static/uploads/website/footer/Google-dark.svg",
          iconDark:
            "https://d1mxd7n691o8sz.cloudfront.net/static/nutrition/nutritiongoal/2023-06/Google_Light-0f53e36e83aa43beaa054bf3c26a69ce.svg",
          text: "play-store",
          external: true,
        },
        {
          link:
            response?.download_app_url?.app_store_link ||
            "https://mindhouse.app.link/bugSoTgftwb",
          icon: "https://d1mxd7n691o8sz.cloudfront.net/static/uploads/website/footer/Apple-dark.svg",
          iconDark:
            "https://d1mxd7n691o8sz.cloudfront.net/static/nutrition/nutritiongoal/2023-06/Apple_Light-6ef14b8a4a4d4f70bfe2ee8b9d016ecd.svg",
          text: "apple-store",
          external: true,
        },
      ],
      image:
        "https://d1mxd7n691o8sz.cloudfront.net/static/uploads/website/footer/footer_illustration.svg",
    },
  };
  data.mobileLink =
    response?.download_app_url?.mobile_link ||
    "https://mindhouse.app.link/bugSoTgftwb";

  return data;
};

const mapTopSectionData = (
  response: any,
  pageType: string | undefined,
  slug: string | undefined
) => {
  const data: any = {};

  let recipeMetaData: any = {};
  let typeText = "";
  if (pageType) {
    if (pageType.toLowerCase() === "collection") {
      recipeMetaData = response?.collectionRecipeData;
      typeText = "collection";
    }
    if (pageType.toLowerCase() === "attributes") {
      recipeMetaData = response?.attributeRecipeData;
      typeText = "attribute";
    }
    if (pageType.toLowerCase() === "category") {
      recipeMetaData = response?.categoryRecipeData;
    }
  }

  data.title =
    recipeMetaData?.h1_heading || "Healthy yet Tasty Recipes by Shyft";
  data.subTitle =
    recipeMetaData.web_description ||
    "Healthy food shouldn't be boring. Get hundreds of healthy yet tasty recipes approved by certified nutritionists. | Shyft Health";
  return data;
};

export const mapRecipes = ({
  cover_image,
  id,
  ingredient_count,
  cooking_time,
  default_rating,
  title,
  slug,
  share_details = [{}],
}) => {
  const shareUrl = share_details?.[0]?.share_url;

  return {
    coverImage: cover_image,
    id,
    ingredientsCount: ingredient_count,
    slug,
    rating: default_rating,
    title,
    cookingTime: cooking_time,
    isFavorite: true,
    shareUrl,
  };
};

export const mapRecipeListData = (
  responseData: any,
  pageType: string | undefined
) => {
  let recipeList: any[] = responseData?.recipeList || [];
  if (pageType) {
    if (pageType.toLowerCase() === "collection") {
      recipeList = responseData?.collectionRecipeData?.recipeList;
    }
    if (pageType.toLowerCase() === "attributes") {
      recipeList = responseData?.attributeRecipeData?.recipeList;
    }
    if (pageType.toLowerCase() === "category") {
      recipeList = responseData?.categoryRecipeData?.recipeList;
    }
  }
  const recipeData = recipeList?.length > 0 ? recipeList : recipes;
  const data = recipeData?.map(mapRecipes);
  return data;
};

export const mapRecipeListPageData = (
  response: any,
  pageType: string | undefined,
  slug?: string | undefined
) => {
  const data: any = {};
  data.downloadBanner = mapDownloadBanner(response);
  data.topSection = mapTopSectionData(response, pageType, slug);
  data.recipeListData = mapRecipeListData(response, pageType);

  return data;
};
